<div class="rd-widget rd-widget-no-height-restriction widget-{{widgetConfig?.widgetId}}">
  <table class="widget-large widgetNoTopBorder cellspacing-0 cellpadding-0"  *ngIf="widgetData" aria-hidden="true">
    <thead>
      <tr class="widget-ruller-large-two-columns-one-gap-fifty-percent">
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
        <th class="widget-grid-column">&nbsp;</th>
      </tr>
    </thead>

    <tbody>
      <tr class="light-grey-line">
        <td colspan="12"><widget-label [widget]="this" [fieldName]="'valuationPortfolioValuationDate'" [align]="'left'">:</widget-label></td>
        <td colspan="21"><widget-value [align]="'left'">{{widgetData.valuationPortfolioValuationDate | rdLocalizedDate}}</widget-value></td>
      </tr>
      <tr class="white-line">
        <td colspan="12"><widget-label [widget]="this" [fieldName]="'reportValuationBasisOfValuation'" [align]="'left'">:</widget-label></td>
        <td colspan="21"><widget-value [align]="'left'">{{widgetData.reportValuationBasisOfValuation}}</widget-value></td>
      </tr>
      <tr class="light-grey-line">
        <td colspan="12"><widget-label [widget]="this" [fieldName]="'reportValuationValuationType'" [align]="'left'"></widget-label></td>
        <td colspan="21"><widget-value [align]="'left'">{{widgetData.reportValuationValuationType}}</widget-value></td>
      </tr>
      <tr class="white-line">
        <td colspan="12"><widget-label [widget]="this" [fieldName]="'reportValuationValuationMethod'" [align]="'left'"></widget-label></td>
        <td colspan="21"><widget-value [align]="'left'">{{widgetData.reportValuationValuationMethod}}</widget-value></td>
      </tr>
      <tr class="light-grey-line">
        <td colspan="12"><widget-label [widget]="this" [fieldName]="'reportValuationIntendedUse'" [align]="'left'"></widget-label></td>
        <td colspan="21"><widget-value [align]="'left'">{{widgetData.reportValuationIntendedUse}}</widget-value></td>
      </tr>
      <tr class="white-line">
        <td colspan="12"><widget-label [widget]="this" [fieldName]="'reportValuationJurisdirection'" [align]="'left'"></widget-label></td>
        <td colspan="21"><widget-value [align]="'left'">{{widgetData.reportValuationJurisdirection}}</widget-value></td>
      </tr>
      <tr class="light-grey-line">
        <td colspan="12"><widget-label [widget]="this" [fieldName]="'reportValuationPartOfAPortfolio'" [align]="'left'"></widget-label></td>
        <td colspan="21"><widget-value [align]="'left'">{{widgetData.reportValuationPartOfAPortfolio}}</widget-value></td>
      </tr>
      <tr class="white-line">
        <td colspan="12"><widget-label [widget]="this" [fieldName]="'valuationPortfolioLiabilityTypeIdDescription'" [align]="'left'"></widget-label></td>
        <td colspan="21"><widget-value [align]="'left'">{{widgetData.valuationPortfolioLiabilityTypeIdDescription}}</widget-value></td>
      </tr>
      <tr><td colspan=33>&nbsp;</td></tr>
      <tr><td colspan=33>&nbsp;</td></tr>
      <tr>
        <td colspan="33"><widget-label [widget]="this" [fieldName]="'labelTerms'" [align]="'left'"></widget-label></td>
      </tr>
    </tbody>
  </table>
</div>
